import { useEffect, useState } from "react";
import { useAuth } from "../auth";
import { supabase } from "../../lib/supabaseClient";

/** true | false | null (null = still checking). UX only — RLS is the real gate. */
export function useIsAdmin() {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(null);
  useEffect(() => {
    let alive = true;
    if (!user?.email) { setIsAdmin(false); return; }
    supabase
      .from("app_users")
      .select("is_admin,status")
      .eq("email", user.email.toLowerCase())
      .maybeSingle()
      .then(({ data }) => alive && setIsAdmin(!!(data?.is_admin && data.status === "active")))
      .catch(() => alive && setIsAdmin(false));
    return () => { alive = false; };
  }, [user?.email]);
  return isAdmin;
}
